module.exports = __webpack_public_path__ + "static/media/sql.09352f39.png";